"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoints = exports.colors = exports.sizes = undefined;

var _exportVariables =
/*#__PURE__*/
require("./export.variables.scss");

var _exportVariables2 =
/*#__PURE__*/
_interopRequireDefault(_exportVariables);

var _helpers =
/*#__PURE__*/
require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Конвертит экспорт из sсss разбивая содержимое по ключам
 *
 * К примеру в файле стилей
 * :export {
 *  colors: {
 *    baseColors: {
 *      black: #000000
 *    }
 *  }
 * }
 * На выходе будет { colors-baseColors: ... }
 *
 * Нам необходимо на выходе  { colors: { baseColors: { ... } } }
 *
 * @param {object} vars объект экспорта scss модуля
 */
var converteExport = function converteExport(vars) {
  return Object.keys(vars).reduce(function (acc, key) {
    var splittedKey = key.split('-');

    if (splittedKey.length > 1) {
      acc[splittedKey[0]] = _objectSpread({}, acc[splittedKey[0]], _defineProperty({}, splittedKey[1], vars[key]));
    } else {
      acc[key] = vars[key];
    }

    return acc;
  }, {});
};
/**
 * Конвертит строку sass карты в объект
 *
 * @param {object} obj
 */


var convertSassStringMapsToObjects = function convertSassStringMapsToObjects(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    acc[key] = (0, _helpers.parseSassMap)(obj[key]);
    return acc;
  }, {});
};

var convertedExport =
/*#__PURE__*/
converteExport(_exportVariables2.default); // Парсим мапы sass-мап

var colors =
/*#__PURE__*/
convertSassStringMapsToObjects(convertedExport.colors);
var sizes =
/*#__PURE__*/
convertSassStringMapsToObjects(convertedExport.sizes); // Парсим простые значения

var breakpoints =
/*#__PURE__*/
(0, _helpers.parseSassMap)(_exportVariables2.default.breakpoints);
exports.sizes = sizes;
exports.colors = colors;
exports.breakpoints = breakpoints;